import {
  TFilter,
  TFilterItem,
  TFilterValue,
} from 'utils/context/FilterContext/types';
import { getKeyByValue, isEmpty } from 'utils/context/FilterContext/utils';
import DK from 'utils/dictionaries/filter_dictionary';

import { DateFormat, formatDateTime } from '@project44/ui-utils';
import { IBasicInventoryOrderSearchCriteria } from '@project44-models/shipment-list';

function mapCheckbox(checkboxes: TFilterValue) {
  const checks = (checkboxes as string[]) || [];
  return checks.map((check) => getKeyByValue(DK, check));
}

const formatTime = (time: string) => {
  return formatDateTime({
    dateTime: new Date(parseInt(time, 10)),
    timeZone: 'UTC',
    dateFormat: "yyyy-MM-dd'T'HH:mm:ssxx" as DateFormat,
  });
};

const mapTime = (value: TFilterValue) => {
  const [start, end] = (value && value[0] && value[0][2]) || [];
  if (start && end) {
    return {
      startDateTime: formatTime(start),
      startDateTimeInclusive: true,
      endDateTime: formatTime(end),
      endDateTimeInclusive: true,
    };
  }
};

const mapSort = ([sortBy, direction]: string[] = []) => {
  if (sortBy && direction) {
    return [
      {
        fieldName: getKeyByValue(DK, sortBy),
        direction: getKeyByValue(DK, direction),
      },
    ];
  }
};

function mapIdentifier(identifier: TFilterItem[] = []) {
  return identifier
    .filter((type) => type.length === 3 && type[2][0])
    .map(([criteria, operator, terms]) => ({
      name: criteria,
      operator: getKeyByValue(DK, operator),
      values: terms,
    }));
}

export const getOrdersRequest = (filters: TFilter) => {
  const searchText = filters[DK.SEARCH_TEXT] as string;
  const sort = mapSort(filters[DK.SORT_BY] as string[]);
  const orderTypes = mapCheckbox(filters[DK.ORDER_TYPE]);
  const statusCodes = mapCheckbox(filters[DK.ORDER_STATUS]);

  const orderSubmissionDateTime = mapTime(filters[DK.ORDER_SUBMISSION_DATE]);
  const originalDeliveryDate = mapTime(filters[DK.ORDER_DUE_DATE]);
  const supplierReadyDate = mapTime(filters[DK.SUPPLIER_READY_DATE]);

  const orderReferenceKey = filters[DK.ORDER_REFERENCE_KEY] as TFilterItem[];
  const orderAttributes = mapIdentifier(orderReferenceKey);

  const request = {
    searchText,
    sort,
    // Checkboxes
    orderTypes,
    statusCodes,
    //Properties
    orderAttributes,
    // Events
    orderSubmissionDateTime,
    originalDeliveryDateTimeWindowStart: originalDeliveryDate,
    supplierReadyDateTimeWindowStart: supplierReadyDate,
  } as IBasicInventoryOrderSearchCriteria;

  const requestKeys = Object.keys(request) as Array<
    keyof IBasicInventoryOrderSearchCriteria
  >;
  requestKeys.forEach((key) => {
    if (isEmpty(request[key])) {
      delete request[key];
    }
  });

  return request;
};
